// utils/cache.js
import { ref } from 'vue';

export const cacheKeyList = ref([]);

// 添加缓存
export function addCache(key) {
    if (!cacheKeyList.value.includes(key)) {
        cacheKeyList.value.push(key);
    }
}

// 移除缓存
export function removeCache(key) {
    const index = cacheKeyList.value.indexOf(key);
    if (index !== -1) {
        cacheKeyList.value.splice(index, 1);
    }
}

// 路由守卫用
export function handleH5Cache(to, from) {
    if (!to.path.match(/^\/h5/)) {
        return
    }
    if (from.meta?.keepCase?.length &&  from.meta.keepCase.includes(to.name)) {
        addCache(from.name)
        from.meta.keepAlive = true;
    } else if (to.meta?.keepCase?.length) {
        addCache(to.name)
        to.meta.keepAlive = true;
    } else {
        from.meta.keepAlive = false

        // 手动清除列表页缓存（关键！）
        if (cacheKeyList.value.includes(from.name)) {
            removeCache(from.name);
        }
    }
}
